import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'reactstrap';

// reactstrap closes a dialog on the Escape keyup; when that Escape was spent closing a tooltip,
// the keyup must not also close the dialog underneath
let isEscapeClosingTooltip = false;
document.addEventListener(
  'keyup',
  event => {
    if (event.key === 'Escape' && isEscapeClosingTooltip) {
      isEscapeClosingTooltip = false;
      event.stopPropagation();
    }
  },
  true
);

/*
A tooltip WCAG 1.4.13 accepts: it opens on hover and on keyboard focus, stays open while the
pointer is over it, and Escape closes it wherever focus is.
*/
const AccessibleTooltip = ({ children, placement, target }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const closeOnEscape = event => {
      if (event.key === 'Escape') {
        isEscapeClosingTooltip = true;
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', closeOnEscape, true);
    return () => document.removeEventListener('keydown', closeOnEscape, true);
  }, [isOpen]);

  // reactstrap hides a tooltip the moment the pointer leaves its target; the short delay lets the
  // pointer cross the gap onto the tooltip, which then stays open while it is hovered
  return (
    <Tooltip
      autohide={false}
      delay={{ show: 0, hide: 300 }}
      isOpen={isOpen}
      placement={placement}
      target={target}
      toggle={() => setIsOpen(!isOpen)}
      trigger="hover focus"
    >
      {children}
    </Tooltip>
  );
};

AccessibleTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  placement: PropTypes.string,
  target: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

AccessibleTooltip.defaultProps = { placement: 'top' };

export default AccessibleTooltip;
